import useAnalytics from "@/hooks/useAnalytics";
import useTranslation from "@/hooks/useTranslation";
import { ProductEol, useDeleteEol } from "@/pages/products/eol/useEol";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { message, Popconfirm } from "antd";
import { ReactNode } from "react";

function DeleteEolAction({
  selectedProducts,
  onSuccess,
  children,
}: {
  selectedProducts: ProductEol[];
  onSuccess: () => void;
  children: ReactNode;
}) {
  const analytics = useAnalytics();
  const deleteEndOfLife = useDeleteEol();
  const translation = useTranslation();
  const onDelete = () => {
    return deleteEndOfLife
      .mutateAsync({
        productIds: selectedProducts.map((product) => product.id),
      })
      .then(() => {
        message.success(translation.eol.deletePopConfirm.successMessage);
        analytics.track("EOL reference deleted");
        onSuccess();
      })
      .catch(() => {
        message.error(translation.errors.general);
      });
  };

  return (
    <Popconfirm
      title={translation.eol.deletePopConfirm.title}
      description={
        <>
          <p>{translation.eol.deletePopConfirm.description}</p>
        </>
      }
      onConfirm={onDelete}
      onCancel={() => {}}
      icon={<ExclamationCircleFilled style={{ color: "#F5222D" }} />}
      okText={translation.eol.deletePopConfirm.okText}
      cancelText={translation.eol.deletePopConfirm.cancelText}
      placement="bottom"
      okType="danger"
      okButtonProps={{ loading: deleteEndOfLife.isLoading }}
    >
      {children}
    </Popconfirm>
  );
}

export default DeleteEolAction;
